import React from 'react';
import { Route } from 'react-router-dom';
import * as ROUTES from '../constants/routes';
import MarketPlaceScreen from '../screens/MarketPlaceScreen';

const MarketPlaceRoutes = () => {
  return (
    <>
      <Route
        path={ROUTES.MARKET_PLACE}
        exact
        component={() => <MarketPlaceScreen />}
      />
    </>
  );
};

export default MarketPlaceRoutes;
